module.exports = __webpack_public_path__ + "img/Menu-03.ce7e111b.png";